import React from 'react';
import { ITheme } from '../Interfaces/ITheme';
import { createTheme, ThemeProvider } from '@mui/material';

const Themes: React.FunctionComponent<ITheme> = ({ children }) => {
  const defaultTheme = createTheme({
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            fontFamily: 'GeneralSans',
            minWidth: '120px',
            fontSize: '16px',
            height: '48px',
            fontWeight: '500',
            borderRadius: '8px',
            textWrap: 'nowrap',
            boxShadow: 'none',
          },
        },
        variants: [
          {
            props: { variant: 'contained' },
            style: {
              background: '#604797',
              color: '#fff',
              padding: '12px',
              ':hover': {
                background: '#604797',
                color: '#fff',
              },
            },
          },
          {
            props: { variant: 'containedII' },
            style: {
              background: '#fff',
              color: '##333333',
              padding: '12px',
              ':hover': {
                background: '#fff',
                color: '##333333',
              },
            },
          },
          {
            props: { variant: 'outlined' },
            style: {
              background: 'white',
              color: '#333333',
              padding: '12px',
              border: '1px solid #D1C8E3',
              ':hover': {
                background: 'white',
                color: '#333333',
              },
            },
          },
          {
            props: { variant: 'text' },
            style: {
              color: '#6A4EA6',
              fontSize: '16px',
              fontWeight: '600',
              minWidth: '0px',
              padding: '4px',
              ':hover': {
                color: '#6A4EA6',
              },
            },
          },
        ],
      },
    },
    typography: {
      allVariants: {
        fontFamily: ['GeneralSans'].join(','),
      },
    },
  });

  return <ThemeProvider theme={defaultTheme}>{children}</ThemeProvider>;
};

export default Themes;
